__turbopack_context__.v({
  "container": "product-configuration-module-scss-module__KIQoMa__container",
  "description": "product-configuration-module-scss-module__KIQoMa__description",
  "image": "product-configuration-module-scss-module__KIQoMa__image",
  "image-container": "product-configuration-module-scss-module__KIQoMa__image-container",
  "image-non-selected": "product-configuration-module-scss-module__KIQoMa__image-non-selected",
  "image-opacity": "product-configuration-module-scss-module__KIQoMa__image-opacity",
  "label-container": "product-configuration-module-scss-module__KIQoMa__label-container",
  "loading-image": "product-configuration-module-scss-module__KIQoMa__loading-image",
  "main-product-container": "product-configuration-module-scss-module__KIQoMa__main-product-container",
  "options": "product-configuration-module-scss-module__KIQoMa__options",
  "options-column-container": "product-configuration-module-scss-module__KIQoMa__options-column-container",
  "options-disabled": "product-configuration-module-scss-module__KIQoMa__options-disabled",
  "products-options-container": "product-configuration-module-scss-module__KIQoMa__products-options-container",
  "title": "product-configuration-module-scss-module__KIQoMa__title",
});
